export { default as SmartBanner } from "./SmartBanner";
